import { ReactNode, useEffect, useState } from 'react';

// eslint-disable-next-line boundaries/element-types
import { useUserProgramsData } from 'widgets/programs/model';
import { getProgramKey } from 'shared/lib/utils';

import { DEFAULT_ILLUSTRATION, PROGRAMS_ILLUSTRATIONS } from './constants';
import styles from './styles.module.scss';

type IllustrationProps = {
  children: ReactNode;
};

export const Illustration = ({ children }: IllustrationProps) => {
  const [illustrationURL, setIllustrationURL] = useState<string>('');

  const { userProgramsData, isLoading } = useUserProgramsData();

  useEffect(() => {
    if (isLoading || !userProgramsData.length) return;

    const { name } = userProgramsData[0];
    const programKey = getProgramKey(name);

    if (programKey) {
      setIllustrationURL(PROGRAMS_ILLUSTRATIONS[programKey]);

      return;
    }

    setIllustrationURL(DEFAULT_ILLUSTRATION);
  }, [isLoading, userProgramsData]);

  return (
    <div
      style={{ backgroundImage: `url(${illustrationURL})` }}
      className={styles.avatarIllustartion}
    >
      {children}
    </div>
  );
};
